import { useEffect, useState } from 'react';
import { useParams } from 'react-router';

import { useCurrentUser, useGetGrowthPlans } from '@/hooks';

import type { GrowthPlan } from '@/types';

import Dashboard from '@/components/Growth/Dashboard';

const Loader = () => {
  const { user } = useCurrentUser();
  const { growthPlanId = '', id: memberId = '' } = useParams();
  const { data: plans, isLoading: isPlansLoading } = useGetGrowthPlans({
    userId: memberId || user.id,
  });
  const [selectedPlan, setSelectedPlan] = useState<GrowthPlan>();

  // check if there is an id on the url route, and pick that plan to show
  useEffect(() => {
    if (growthPlanId !== '' && plans.length) {
      const found = plans.findIndex(({ id }) => id === growthPlanId);
      setSelectedPlan(plans[found]);
    } else if (plans[0]) {
      setSelectedPlan(plans[0]);
    }
  }, [growthPlanId, plans]);

  if (isPlansLoading || !selectedPlan) return null;

  return <Dashboard />;
};

export default Loader;
